import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconNames } from '../../../common/constants/icon-names';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-tracking-map-card',
  imports: [CommonModule, SvgIconComponent, MatCard, MatCardTitle, MatCardContent, TranslateModule],
  templateUrl: './tracking-map-card.component.html',
  styleUrls: ['./tracking-map-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingMapCardComponent {
  @Input() title = 'transportOrder.tracking.title';
  iconNames = IconNames;
}
